import React from 'react'
import PropTypes from 'prop-types'
import FormattedCheckbox from '../FormattedCheckbox'

const InterestButton = ({ interestName, onClick, checked }) => (
  <button onClick={onClick} type="button" className="flex items-center mt-2 text-sm">
    <FormattedCheckbox valid={true} checked={checked} />
    <div>{interestName}</div>
  </button>
)

InterestButton.propTypes = {
  interestName: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired
}

export default InterestButton